import { createORPCClient } from '@orpc/client';
import { RPCLink } from '@orpc/client/fetch';
import { RouterClient } from '@orpc/server';
import type { router } from '../worker/router';

export function createSearchClient(url: string) {
	const link = new RPCLink({
		url: url ?? 'sff-search.daniellever.com',
		// headers: () => ({
		// 	authorization: 'Bearer token',
		// })
	});

	const rpc: RouterClient<typeof router> = createORPCClient(link);
	return rpc;
}

export type SearchClient = RouterClient<typeof router>;
